import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"

export type SearchDrawerProps = {
    open: boolean
    onClose: () => void
    text: any
    children: React.ReactNode
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}
const SearchDrawer = memo(({open, onClose, text, children, templating}: SearchDrawerProps) => {
    const TemplatedDrawer = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <TemplatedDrawer open={open} onClose={onClose} text={text} data-testid="search-templated-drawer">
                {children}
            </TemplatedDrawer>
        </Suspense>
    )
})
SearchDrawer.displayName = "SearchDrawer"

export default SearchDrawer
